module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "checkbox-demo",
    attrs: {
      "title": "Checkbox"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('CheckBox', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("小")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("中等")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  }, [_vm._v("大")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "value",
      "description": "指定值",
      "code": _vm.value_code
    },
    slot: "right"
  }, [_c('CheckBox', {
    attrs: {
      "value": 'small'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("小")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "value": 'normal'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("中等")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "value": 'large'
    },
    model: {
      value: (_vm.test_value),
      callback: function($$v) {
        _vm.test_value = $$v
      },
      expression: "test_value"
    }
  }, [_vm._v("大")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_value)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disable_code
    },
    slot: "left"
  }, [_c('CheckBox', {
    model: {
      value: (_vm.test_disable),
      callback: function($$v) {
        _vm.test_disable = $$v
      },
      expression: "test_disable"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.test_disable),
      callback: function($$v) {
        _vm.test_disable = $$v
      },
      expression: "test_disable"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_disable)))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('CheckBox', {
    model: {
      value: (_vm.test_color),
      callback: function($$v) {
        _vm.test_color = $$v
      },
      expression: "test_color"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "color": 'rgb(0, 160, 233)'
    },
    model: {
      value: (_vm.test_color),
      callback: function($$v) {
        _vm.test_color = $$v
      },
      expression: "test_color"
    }
  }, [_vm._v("蓝色")]), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.test_color)))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36608c77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/CheckBox.vue
// module id = 632
// module chunks = 0